<template>
  <div>
    <div v-if="!url" class="loading_popup" style="display: block">
      <div>
        <div></div>
        <div>加载中...</div>
      </div>
    </div>
    <div v-else style="height: calc(100vh - 110px)">
      <iframe style="height: 100%; width: 100%" :src="url" scrolling="auto" frameborder="0" class="trend-container2" id="iframe"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'kefu',
  data() {
    return {
      url: null,
    };
  },
  components: {},
  created() {
    let that = this;
    that.$apiFun.post('/api/getservicerurl', {}).then(res => {
      if (res.code != 200) {
        that.showTost(0, res.message);
      }
      if (res.code == 200) {
        that.url = res.data.url;
      }
    });
  },
  mounted() {
    let that = this;

    if (window.history && window.history.pushState) {
      // 向历史记录中插入了当前页
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    }
  },
  methods: {
    goBack() {
      let that = this;
      console.log(123);
      that.$router.push({ path: '/' });

      return;
    },
  },
  destroyed() {
    //离开这个界面之后，删除事件
    window.removeEventListener('popstate', this.goBack, false);
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mode/kefu.vue